"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _constants = require("../utils/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _inlineHelp = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/inline-help.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _inlineHelp.default);
/** **InlineHelp** is used to display help text in a **Popover**, often inline with headers,
body text and form labels. */

var InlineHelp = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var text = _ref.text,
      placement = _ref.placement,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      contentClassName = _ref.contentClassName,
      buttonLabel = _ref.buttonLabel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["text", "placement", "className", "cssNamespace", "contentClassName", "buttonLabel"]);
  var inlineHelpClasses = classnames("".concat(cssNamespace, "-inline-help"), className);
  var inlineHelpContentClasses = classnames("".concat(cssNamespace, "-inline-help__content"), "".concat(cssNamespace, "-no-border"), contentClassName);

  var control = /*#__PURE__*/_react.default.createElement("span", {
    "aria-label": buttonLabel,
    className: inlineHelpClasses,
    ref: ref,
    role: "button",
    tabIndex: "0"
  });

  var body = /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: inlineHelpContentClasses
  }), text);

  return /*#__PURE__*/_react.default.createElement(_Popover.default, {
    body: body,
    control: control,
    placement: placement
  });
});

InlineHelp.displayName = 'InlineHelp';
process.env.NODE_ENV !== "production" ? InlineHelp.propTypes = {
  /** Localized text for aria-label on button for screen readers */
  buttonLabel: _propTypes.default.string.isRequired,

  /** Localized text to display in the inline help pop-up */
  text: _propTypes.default.string.isRequired,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Class names to be added to the `<span>` element */
  contentClassName: _propTypes.default.string,

  /** Location to display the inline help pop-up relative to the image:
  'bottom-start',
  'bottom',
  'bottom-end',
  'left-start',
  'left',
  'left-end',
  'right-start',
  'right',
  'right-end',
  'top-start',
  'top',
  'top-end' */
  placement: _propTypes.default.oneOf(_constants.POPPER_PLACEMENTS)
} : void 0;
InlineHelp.defaultProps = {
  placement: 'bottom'
};

var _default = (0, _withStyles.default)(InlineHelp);

exports.default = _default;